import React from 'react';
import { Box, Skeleton, Grid, alpha, useTheme } from '@mui/material';

const PageLoader = ({ type = 'list', count = 5 }) => {
    const theme = useTheme();

    const renderDashboardSkeleton = () => (
        <Box>
            {/* Stats Row */}
            <Grid container spacing={3} sx={{ mb: 6 }}>
                {[1, 2, 3, 4].map((i) => (
                    <Grid xs={12} sm={6} md={3} key={i}>
                        <Skeleton
                            variant="rectangular"
                            height={140}
                            sx={{ borderRadius: 5, bgcolor: alpha(theme.palette.primary.main, 0.05) }}
                        />
                    </Grid>
                ))}
            </Grid>

            {/* Chart Section */}
            <Skeleton
                variant="rectangular"
                height={400}
                sx={{ borderRadius: 5, bgcolor: alpha(theme.palette.primary.main, 0.02) }}
            />
        </Box>
    );

    const renderListSkeleton = () => (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {[...Array(count)].map((_, i) => (
                <Skeleton
                    key={i}
                    variant="rectangular"
                    height={80}
                    sx={{
                        borderRadius: 4,
                        bgcolor: alpha(theme.palette.primary.main, 0.03),
                        animationDelay: `${i * 0.1}s`
                    }}
                />
            ))}
        </Box>
    );

    const renderCardSkeleton = () => (
        <Grid container spacing={4}>
            {[...Array(count)].map((_, i) => (
                <Grid xs={12} md={6} lg={4} key={i}>
                    <Box sx={{ p: 3, borderRadius: 5, border: `1px solid ${alpha(theme.palette.divider, 0.5)}` }}>
                        <Skeleton variant="circular" width={40} height={40} sx={{ mb: 2 }} />
                        <Skeleton variant="text" sx={{ fontSize: '1.5rem', mb: 1 }} />
                        <Skeleton variant="text" sx={{ fontSize: '1rem', mb: 3 }} />
                        <Skeleton variant="rectangular" height={150} sx={{ borderRadius: 3 }} />
                    </Box>
                </Grid>
            ))}
        </Grid>
    );

    return (
        <Box sx={{ width: '100%', animation: 'fadeIn 0.5s ease' }}>
            {/* Common Header Skeleton */}
            <Box sx={{ mb: 6 }}>
                <Skeleton variant="text" width="40%" height={60} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="60%" height={30} />
            </Box>

            {type === 'dashboard' && renderDashboardSkeleton()}
            {type === 'list' && renderListSkeleton()}
            {type === 'grid' && renderCardSkeleton()}
        </Box>
    );
};

export default PageLoader;
